import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueApexCharts from "vue-apexcharts";

import App from "./App.vue";

import CurrencyMixin from "./mixins/CurrencyMixin";
import DateMixin from "./mixins/DateMixin";

import vuetify from "./plugins/vuetify";
import "./plugins/leaflet";

import router from "./router";
import i18n from "./i18n";

import "swiper/css/swiper.css";

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

Vue.mixin(DateMixin);
Vue.mixin(CurrencyMixin);

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
